import React from 'react';
import { connect } from 'react-redux';
import { separator } from '../utils/separator';
import {
  InfoCircleOutlined,
  LinkOutlined,
  DollarOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons';
import { Button, Modal, message, Popconfirm } from 'antd';
import axios from 'axios';
import { hostServer } from '../actions/consts/host';
import { addCredit } from '../actions/finance';
import { startGettingPlans } from '../actions/plans';
import '../styles/components/charge-popup.scss';

class ChargePopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: this.props.amount || 50000,
      goal: this.props.goal || 'charge',
      planName: this.props.planName,
      period: this.props.period || null,
      docModalVisible: false,
      hasOrganization: null,
    };
  }

  changeAmount = (e) => {
    // handle both button (value with commas) and number input
    const raw = String(e.target.value || '');
    const amount = parseInt(raw.replace(/,/g, ''), 10);
    this.setState({ amount });
  };

  showDocModal = () => {
    this.setState({ docModalVisible: true });
  };

  hideDocModal = () => {
    this.setState({ docModalVisible: false });
  };

  openPlans = () => {
    // Close the current charge modal and open plans popup
    if (this.props.close) {
      this.props.close();
    }
    // Trigger the parent to open plans popup
    if (this.props.onOpenPlans) {
      this.props.onOpenPlans();
    }
  };

  stopPropagation = (e) => {
    e.stopPropagation();
  };

  checkOrganization = async () => {
    try {
      const header = {
        headers: {
          Authorization: `Token ${this.props.uid}`,
        },
      };
      const { data } = await axios.get(
        `${hostServer}/api/v1/users/check_organization`,
        header
      );
      this.setState({
        hasOrganization: data.has_organization || false,
      });
    } catch (error) {
      console.error('Error checking organization:', error);
      this.setState({
        hasOrganization: false, // Default to false on error
      });
    }
  };

  handleAddCredit = async () => {
    try {
      // Validate amount before proceeding
      if (!this.state.amount || this.state.amount <= 0) {
        message.error('لطفاً مبلغ معتبری وارد کنید.');
        return;
      }

      if (this.state.amount < 1000) {
        message.error('حداقل مبلغ قابل افزودن ۱,۰۰۰ تومان است.');
        return;
      }

      if (this.state.amount > 5000000) {
        message.error('حداکثر مبلغ قابل افزودن ۵,۰۰۰,۰۰۰ تومان است.');
        return;
      }

      await this.props.addCredit(this.state.amount);
      // The addCredit action handles success/error messages internally
    } catch (error) {
      console.error('Error in handleAddCredit:', error);
      message.error('خطا در افزودن اعتبار. لطفاً دوباره تلاش کنید.');
    }
  };

  componentDidMount() {
    this.checkOrganization();
    // Fetch plans if not already loaded
    if (!this.props.plans || this.props.plans.length === 0) {
      this.props.startGettingPlans();
    }
  }

  getPlanPrices = () => {
    if (!this.props.plans || this.props.plans.length === 0) {
      return [89000, 890000]; // Fallback to Silver and Gold prices
    }

    // Get Silver and Gold plans specifically
    const silverGoldPlans = this.props.plans
      .filter(
        (plan) =>
          plan.is_active && (plan.name === 'Silver' || plan.name === 'Gold')
      )
      .sort((a, b) => a.level - b.level);

    // Extract monthly prices (default_cost) from Silver and Gold plans
    const prices = silverGoldPlans
      .map((plan) => plan.default_cost)
      .filter((price) => price > 0); // Only include paid plans

    // If we don't have both plans, use fallback values
    if (prices.length < 2) {
      return [89000, 890000]; // Silver and Gold fallback prices
    }

    return prices;
  };

  render() {
    const stop = this.stopPropagation;
    const planPrices = this.getPlanPrices();

    return (
      <div className="charge-popup-body">
        <div className="card-inner">
          <h3>افزایش اعتبار حساب</h3>
          <div className="default-cashes">
            {planPrices.map((price, index) => (
              <input
                key={index}
                className={`cash-item ${
                  this.state.amount === price ? 'active' : ''
                }`}
                type="button"
                value={separator(price)}
                onClick={this.changeAmount}
              />
            ))}
          </div>
          <div className="cash-input">
            <input
              type="number"
              value={this.state.amount}
              onChange={this.changeAmount}
              step={1000}
            />
            <p>تومان</p>
          </div>
        </div>

        {this.state.hasOrganization === false && (
          <Button
            type="primary"
            shape="round"
            icon={<InfoCircleOutlined />}
            size="large"
            onClick={this.showDocModal}
            className="charge-popup--doc"
          >
            اتصال حساب آپداموس به کنسول
          </Button>
        )}

        {this.state.hasOrganization === true && (
          <div className="charge-popup--buttons-container">
            <Popconfirm
              title={`آیا می‌خواهید ${separator(
                this.state.amount
              )} تومان به حساب خود اضافه کنید؟`}
              onConfirm={this.handleAddCredit}
              okText="بله، افزایش اعتبار"
              cancelText="خیر"
              placement="top"
            >
              <Button
                type="primary"
                shape="round"
                size="large"
                className="charge-popup--pay"
                loading={this.props.fetchInProgress}
              >
                افزایش اعتبار حساب با اعتبار کنسول
              </Button>
            </Popconfirm>
            <Button
              type="default"
              shape="round"
              size="large"
              icon={<ShoppingCartOutlined />}
              onClick={this.openPlans}
              className="charge-popup--plans"
            >
              مشاهده پلن‌ها
            </Button>
          </div>
        )}

        <Modal
          title={
            <div className="modal-title">
              <InfoCircleOutlined className="modal-title-icon" />
              راهنمای افزایش موجودی حساب
            </div>
          }
          visible={this.state.docModalVisible}
          onCancel={() => {}} // intentionally no-op
          maskClosable={false}
          closable={false}
          keyboard={false}
          footer={[
            <Button
              key="close"
              onClick={this.hideDocModal}
              className="modal-close-btn"
              size="large"
            >
              بستن
            </Button>,
          ]}
          width={700}
          dir="rtl"
          className="budget-modal"
          centered
          destroyOnClose
        >
          <div
            className="budget-doc-content"
            onMouseDownCapture={stop}
            onMouseDown={stop}
            onClickCapture={stop}
            onClick={stop}
          >
            <div className="steps-container">
              <h4 className="steps-title">مراحل افزایش موجودی حساب:</h4>

              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h5 className="step-title">ثبت‌نام و ورود به کنسول همروش</h5>
                  <div className="step-details">
                    <div className="step-detail-item">
                      <span className="step-icon">🏦</span>
                      <span>
                        با ایمیلی که در آپداموس ثبت‌نام و کرده‌اید وارد{' '}
                        <a
                          href="https://console.hamravesh.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="console-link"
                          onMouseDownCapture={stop}
                          onMouseDown={stop}
                          onClickCapture={stop}
                          onClick={stop}
                        >
                          <LinkOutlined className="link-icon" />
                          کنسول همروش
                        </a>{' '}
                        خود شوید. در صورت نداشتن حساب در کنسول، با همان ایمیل یک
                        حساب کاربری جدید در کنسول ایجاد کنید.
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h5 className="step-title">افزایش اعتبار در کنسول</h5>
                  <div className="step-details">
                    <div className="step-detail-item">
                      <span className="step-icon">💰</span>
                      <span>
                        از بخش{' '}
                        <a
                          href="https://console.hamravesh.com/financial/invoices/current"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="console-link"
                          onMouseDownCapture={stop}
                          onMouseDown={stop}
                          onClickCapture={stop}
                          onClick={stop}
                        >
                          <DollarOutlined className="link-icon" />
                          مدیریت حساب
                        </a>{' '}
                        در کنسول، مبلغ موردنظر را برای افزایش اعتبار انتخاب
                        کنید. توجه داشته باشید که میزان اعتبار را با توجه به پلن
                        انتخابی خود اضافه کنید.
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h5 className="step-title">اتصال آپداموس به کنسول</h5>
                  <div className="step-details">
                    <div className="step-detail-item">
                      <span className="step-icon">🎫</span>
                      <span>
                        برای اتصال اکانت آپداموس خود به اکانت کنسول خود{' '}
                        <a
                          href="https://console.hamravesh.com/ticketing"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="console-link"
                          onMouseDownCapture={stop}
                          onMouseDown={stop}
                          onClickCapture={stop}
                          onClick={stop}
                        >
                          <LinkOutlined className="link-icon" />
                          تیکت
                        </a>{' '}
                        ثبت کنید و عنوان تیکت را{' '}
                        <span
                          style={{ userSelect: 'text', fontWeight: 'bold' }}
                        >
                          اتصال حساب آپداموس به کنسول
                        </span>{' '}
                        تنظیم کنید
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fetchInProgress: state.fetchInProgress,
  uid: state.auth.uid,
  plans: state.plans.plans || [],
});

const mapDispatchToProps = (dispatch) => ({
  addCredit: (amount, description) => dispatch(addCredit(amount, description)),
  startGettingPlans: () => dispatch(startGettingPlans()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChargePopUp);
